import moment from 'moment-timezone';
import store from '../store';

export const answerStatusMap = {
  draft: { label: 'Черновик', background: 'rgb(0, 0, 0)', color: '#ffffff' },
  sent: { label: 'Отправлен', background: 'rgb(225, 225, 225)', color: '#000000' },
  accept: { label: 'Принят', background: 'rgb(76, 175, 80)', color: '#ffffff' },
  return: { label: 'Возврат', background: 'rgb(251, 139, 0)', color: '#ffffff' },
};

export const newAnswerStatus = {
  new: { label: 'Новое', background: 'rgb(0, 114, 188)', color: '#ffffff' },
};

/**
 * Возвращает цвет группы
 * @param classId
 */
export const getClassColor = (classId) => {
  const cl = store.getters.classes.find(c => c.id === classId);
  return (cl && cl.color) ? cl.color : '#fff';
};

/**
 * Возвращает полное название группы
 * @param classId
 */
export const getClassName = (classId) => {
  const cl = store.getters.classes.find(c => c.id === classId);
  if (!cl) {
    return '';
  }
  const course = store.getters.courses.find(c => c.id === cl.courseId);
  if (!course) {
    return '';
  }

  const filial = store.getters.filials.find(f => f.id === cl.filialId);
  if (!filial) {
    return '';
  }

  let name = '';

  if (course.name) {
    name += course.id === 0 ? 'Инд. обучение' : course.name;
  }

  if (name && (cl.showDates || cl.name)) {
    name += ' -';
  }
  if (cl.showDates && cl.beginDate) {
    name += moment(cl.beginDate).tz(filial.timezone).format(' DD/MM HH:mm');
  }

  if (cl.name) {
    name += ` ${cl.name}`;
  }
  return name;
};

/**
 * Проверяет, можно ли ученику записываться на занятие.
 */
export const checkAllowRecord = (lesson, user) => {
  const { UISettings, filials, classes } = store.getters;
  if (!UISettings || !UISettings.allowRecords || !lesson) {
    return false;
  }
  const cl = classes.find(c => c.id === lesson.classId);
  if (!cl) {
    return false;
  }
  const filial = filials.find(f => f.id === cl.filialId);
  if (!filial) {
    return false;
  }
  const timeout = moment.tz(`${lesson.date} ${lesson.beginTime}:00`, filial.timezone)
    .subtract(UISettings.allowRecordsTimeout, 'minutes');
  const tzNow = moment().tz(filial.timezone);

  if (timeout < tzNow) {
    return false;
  }
  const join = user.joins
    .find(j => j.classId === lesson.classId);
  if (!join && (cl.freeRecords === 0 || cl.status !== 'opened')) {
    // Если у ученика нет записи в группу и группа заполнена,
    // то нельзя записаться
    return false;
  }

  const lastDay = moment().add(UISettings.daysForRecord, 'day').format('YYYY-MM-DD');
  const lastDayIndv = moment().add(UISettings.daysForRecordIndividual, 'day').format('YYYY-MM-DD');

  const lastDayGroup = moment(`${lastDay} 23:59:59`).tz(filial.timezone);
  const lastDayIndivid = moment(`${lastDayIndv} 23:59:59`).tz(filial.timezone);

  if (cl.courseId === 0 && (timeout > lastDayIndivid)) {
    return false;
  }

  if (cl.courseId !== 0 && (timeout > lastDayGroup)) {
    return false;
  }

  return cl && UISettings.allowRecords
    && (lesson.freeRecords !== 0);
};

export const checkCancelRecord = (lesson) => {
  const { UISettings, filials, classes } = store.getters;
  if (!UISettings || UISettings.cancelRecords === 'no' || !lesson) {
    return false;
  }
  const cl = classes.find(c => c.id === lesson.classId);
  if (!cl) {
    return false;
  }
  const filial = filials.find(f => f.id === cl.filialId);
  if (!filial) {
    return false;
  }
  const timeout = moment.tz(`${lesson.date} ${lesson.beginTime}:00`, filial.timezone)
    .subtract(UISettings.cancelRecordsTimeout, 'minutes');
  const tzNow = moment().tz(filial.timezone);

  if (timeout < tzNow) {
    return false;
  }

  return UISettings.cancelRecords === 'yes' || cl.allowCancelRecords;
};

export const checkIfFrozen = (lesson, user) => (
  lesson.frozenUsers && lesson.frozenUsers.includes(user.id)
);
